import { composeIO } from 'react-compose-io'
import { modalDesativarIO } from './ModalDesativar.IO'
import { ModalDesativarView } from './ModalDesativar.View'

export const ModalDesativar = composeIO(ModalDesativarView, modalDesativarIO)
